import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import VueBase from '@/VueBase';
import { locales } from '@/i18n-setup';
import helper from '@/services/helper';
import Q from 'q';
import api from '@/services/api';
import VueRecaptcha from 'vue-recaptcha';

import printerApi from '@/services/printer';

@Component({
  computed: {
    ...mapState({
      ShowLanguages: 'ShowLanguages',
      ShowPrinter: 'ShowPrinter',
      CaptchaKey: 'CaptchaKey',
      ShowCaptcha: 'ShowCaptcha',
    }),
  },
})
export default class StationLoginMixins extends VueBase {
  public readonly ShowLanguages!: string;
  public readonly ShowPrinter!: boolean;
  public readonly CaptchaKey!: string;
  public readonly ShowCaptcha!: boolean;

  public Username: string = '';
  public Password: string = '';
  private tocken: string = ''; 

  
  getRecaptcha() {
    return this.$refs.recaptcha as VueRecaptcha;
  }
  public onVerifyCaptcha(response: string) {
    this.tocken = response;
  }

  async onLoginClick() {
    if (this.ShowPrinter) {
      if (!printerApi.isBluetoothPrinterConnected()) {
        helper.swalWarning(this.$t('vs.printer.error.noconnection') as string);
        return;
      }
      if (printerApi.isLowOnPaperOrNoConnection()) {
        helper.swalWarning(this.$t('vs.printer.error.lowpaper') as string);
        return;
      }
    }

    var username = this.Username;
    var password = this.Password;
    if (!username || username.length === 0) {
      helper.swalWarning(this.$t('vs.api.error.IdNumberRequired'));
      return;
    }
    if (!password || password.length === 0) {
      helper.swalWarning(this.$t('vs.api.error.PasswordRequired'));
      return;
    }
    
    if(this.ShowCaptcha) {
      if (!this.tocken || this.tocken.length === 0) {
        helper.swalWarning(this.$t('vs.api.error.ConfirmCaptcha'));
        return;
      }
    }

    helper.swalShowLoading();
    var promise = Q.delay(500);
    const user = await (await api.StationLogin(username, password, this.tocken)).getData(true);
    
    if(this.ShowCaptcha) {
      let el = this.getRecaptcha();
      if(el) el.reset();
    }
    if (!user) return;

    await api.Init();
    this.$store.commit('StationLogin', user);
    await promise;

    printerApi.setDirection('LEFT');
    printerApi.printLine('Login OK');
    printerApi.printLine(`Voting Station: ${user}`);
    printerApi.printLine('Ready');

    if (process.env.VUE_APP_MODE === 'SA') {
      this.$router.push({ name: 'VoterAssign' });
    }
    if (process.env.VUE_APP_MODE === 'CS') {
      this.$router.push({ name: 'Start' });
    }

    await Q.delay(500);
    helper.close();
  }

  onPrinterSettingsClick() {
    printerApi.showSettingsScreen();
  }
}
